import { Component, EventEmitter, Input, Output } from '@angular/core';
import { isNil } from 'lodash';

@Component({
  selector: 'app-description-main',
  templateUrl: './description-main.component.html',
  styleUrls: ['./description-main.component.scss'],
})
export class DescriptionMainComponent {
  isEditMode: any;
  @Input() consumers: any[] = [];
  @Input() producers: any[] = [];
  @Input() plantTypes: any[] = [];
  @Output() assetSelectEmitter = new EventEmitter();
  @Output() plantTypeSelectEmitter = new EventEmitter();

  public displayConsumerName(consumer: any) {
    if (isNil(consumer) || isNil(consumer.name) || consumer.name === '') {
      if (isNil(consumer.buildingType) || consumer.buildingType.name === '' || isNil(consumer.buildingType.name)) {
        return 'Verbraucher';
      }
      return consumer.buildingType.name;
    }
    return consumer.name;
  }

  public selectAsset(asset: any) {
    this.assetSelectEmitter.emit(asset);
  }

  public selectPlantType(type: any) {
    this.plantTypeSelectEmitter.emit(type);
  }

  trackByFnConsumer(_: number, item: any) {
    return item.guid;
  }

  trackByFnPlantType(_: number, item: any) {
    return item;
  }
}
